import jwt_decode from 'jwt-decode';
/**
 * This utility method will receive an encoded JWT and then it will return
 * the decoded version.
 */
export const JWTDecoder = (jwt: string) => (jwt ? jwt_decode(jwt) : null);
